<app-ion-page-container [headerName]="text">
  <app-ion-page-content>
    <div class="coming-soon">
      <app-text [textSize]="TextSizes.h2Menu" [textType]="TextType.base" [text]="text"></app-text>
    </div>
  </app-ion-page-content>
</app-ion-page-container>
